import { render, staticRenderFns } from "./inventarios.vue?vue&type=template&id=6d622f36&scoped=true"
import script from "./inventarios.vue?vue&type=script&lang=js"
export * from "./inventarios.vue?vue&type=script&lang=js"
import style0 from "./inventarios.vue?vue&type=style&index=0&id=6d622f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d622f36",
  null
  
)

export default component.exports